import 'regenerator-runtime/runtime';
import { all } from 'redux-saga/effects';
import WatchCommon from '../Common/saga';
import WatchUser from '../User/saga';
import WatchAuth from '../Auth/saga';
import WatchLots from '../Lots/saga';
import WatchRequestTypes from '../Request-Types/saga';
import WatchRoom from '../Rooms/saga';
import WatchWorkOrder from '../Work-Orders/saga';
import WatchRequestService from '../Request-Services/saga';
import WatchProjects from '../Projects/saga';
export default function* rootSaga() {
  yield all([
    WatchCommon(),
    WatchUser(),
    WatchAuth(),
    WatchLots(),
    WatchRequestTypes(),
    WatchRoom(),
    WatchWorkOrder(),
    WatchRequestService(),
    WatchProjects()
  ]);
}



// WEBPACK FOOTER //
// ./src/portal_homeowner/saga.js